module.exports = {
      id: "ic-historical-light-active-usage",
      viewBox: "0 0 160 120",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-historical-light-active-usage",
      toString: function () {
        return this.url;
      }
    }